module.exports = __webpack_public_path__ + "img/IMG_0328_L_Wood.3f1ded3f.jpg";